import React from "react";
import PropTypes from "prop-types";
import { dateToOnlyTimeString } from "../utils/date-time-helper";

export const PillsDialogContent = ({
  availableTimes = [],
  value,
  handleTimeChange,
  components,
  invalid = false
}) => {
  const { Pills } = components;

  return (
    <div className='form-calendar-wrapper-web-sdk'>
      <Pills
        width={80}
        options={availableTimes.map(time => ({
          value: time.getTime(),
          text: dateToOnlyTimeString(time)
        }))}
        value={value?.getTime()}
        onChange={handleTimeChange}
        invalid={invalid}
      />
    </div>
  );
};

PillsDialogContent.propTypes = {
  availableTimes: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  value: PropTypes.instanceOf(Date),
  handleTimeChange: PropTypes.func.isRequired,
  components: PropTypes.objectOf(PropTypes.func).isRequired,
  invalid: PropTypes.bool
};
